import { FrameBody, Title, Wait} from "@npd-ng/adp-benchmark";
import { useStateContext } from "../hooks/useStateContext";
import { useState} from "react";
import { Content } from "../types/Content";
import HeartbeatService from "../services/HeartbeatService";
import { useDeviceValidationService } from "../hooks/useDeviceValidationService";
import successIcon from '../assets/success.svg';
import waitIcon from '../assets/waiting.svg'
import waitIconBkgrnd from '../assets/waiting_background.svg';
import warning from '../assets/warning.svg';
import error from '../assets/error_icon.svg'
import incomplete from '../assets/incomplete.svg'
import { Button, Image} from "react-bootstrap";
import { Col, Container, Row } from "react-bootstrap";
import { Interweave } from "interweave";
import { StressTest, actions } from "../state";
import { AppStateProvider } from "../state/Provider";
import { useDedupEffect } from "../util/useDedupEffect";



export default function DeviceReadinessView() {
  const { state,dispatch} = useStateContext();
  const content= state.staticContent as Content;
   const deviceReadiness = content.deviceReadiness;
   const {performOnlineDeviceValidation,performStressTest,postStressTestDeviceMetrics,performNCSModeDeviceValidation} = useDeviceValidationService(dispatch,state);
   const [deviceValidationInProgress,isDeviceValidationInProgress] = useState(true);
   const [manualSkip, setManualSkip] = useState(false);
   const [heartbeatAction, setHeartbeatAction] = useState("");
   function ReadinessWaitView () {
     return (
       <div className="setupCodeWaitview">
         <Wait
           title={content.deviceReadiness.results.wait.title}
           />
     </div>
     )
   }
  function WaitView () {
    return (
      <div className="stressTestWaitview">
        <Wait
          title={content.deviceReadiness.results.stressTest.title}
          />
      </div>
    )
  }
    
   const onSkipStressTest = ()=>{
     const strestTestState: StressTest = {
      state: "Skipped",
      stressTestPassed: true,
     }
     dispatch(actions.createSetStressTestAction(strestTestState));
     postStressTestDeviceMetrics(strestTestState);
     HeartbeatService.cancelHeartbeat();
     HeartbeatService.init(state,true);
     setManualSkip(true);
     //performStressTest();
   };
   const onLaunchAssessment = ()=>{
    dispatch(actions.createSetViewAction("RedirectionView"));
   };
   const executeStressTest=async ()=>{
     const provider = AppStateProvider.getInstance();
     const state = provider.getState();
    if(state.deviceReadinessState?.deviceReadinessInfo?.state === "WaitingForStressTest"){
      if(heartbeatAction === "SkipNetworkStressTest"){
        const strestTestState: StressTest = {
          state: "Skipped",
          stressTestPassed: true,
         }
         await postStressTestDeviceMetrics(strestTestState);
         dispatch(actions.createSetStressTestAction(strestTestState));
         dispatch(actions.createSetViewAction("RedirectionView"));
      }
      else if(heartbeatAction === "PerformNetworkStressTest"){
        HeartbeatService.init(state,true);
        const stressTest:StressTest = {
          state: "InProgress",
          stressTestPassed: false
        } 
        dispatch(actions.createSetStressTestAction(stressTest));
         const results = await performStressTest(state.appState.configuration);
         if(results.isClassroomStressTestPassed){
          dispatch(actions.createSetViewAction("RedirectionView"));
         }
         HeartbeatService.cancelHeartbeat();
      }
    };
    HeartbeatService.cancelHeartbeat();
   }
   const onHeartBeatAction = async (action:string)=>{
    setHeartbeatAction(action);
   };
   useDedupEffect(()=>{
    executeStressTest();
   },[heartbeatAction])

   useDedupEffect(() => {
    //10/24 = moved HB to start only after the device validation performed. Handle potential race condition when command arrives , but device is not ready to start the stress test 
    if(state.sessionState.selectedAssessmentMode === "ncs"){
      performNCSModeDeviceValidation().then((result)=>{
        HeartbeatService.init(state,false,onHeartBeatAction);
        isDeviceValidationInProgress(false);
        if(result) {
          dispatch(actions.createSetViewAction("RedirectionView"));
        }
      });
    }
    else {
      performOnlineDeviceValidation().then(async (result)=>{
        HeartbeatService.init(state,false,onHeartBeatAction);
        if(result) {
          if(state.deviceState.deviceType === "SBE"){
            const strestTestState: StressTest = {
              state: "Skipped",
              stressTestPassed: true,
             }
             await postStressTestDeviceMetrics(strestTestState);
             dispatch(actions.createSetStressTestAction(strestTestState));
          }
            isDeviceValidationInProgress(false);
        }
      });
    }
  }, []);
    return (
      <FrameBody>
         <Title content={deviceReadiness.title}/>
       {deviceValidationInProgress && ReadinessWaitView()}
       {state.networkReadinessState.executionState.state === "InProgress" && WaitView()} 
      {state.networkReadinessState.executionState.state !== "InProgress"  &&  <>
       {!deviceValidationInProgress &&
      <>
       <Container fluid className="resultsContainer">
      {
        <div className="resultWrapper">
       
       {state.deviceState.deviceType === "SBE" ? ( 
        <Row className="resultsRow">
              <Col>
                  <span><Image className="resultsIcon" src={successIcon}/>
                 <span className="resultsHeader networkAlignment"> {deviceReadiness.results.sbe.title}</span>
                 <br/>
                 <span className="SBESubText"><Interweave content={deviceReadiness.results.sbe.message}/></span>
                 </span>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                </Col>
                </Row>
                ) : (
                  <>
                  <Row className="resultsRow">
              <Col>
              <span><Image className="resultsIcon" src={successIcon}/>

              <span className="resultsHeader">{state.sessionState.selectedAssessmentMode === "online" ? deviceReadiness.results.launchMode.online.header : deviceReadiness.results.launchMode.ncs.header}
              <span className="resultsBold">{state.sessionState.selectedAssessmentMode === "online" ? deviceReadiness.results.launchMode.online.state : deviceReadiness.results.launchMode.ncs.state}</span>
              </span>
              <div className="resultsSubText"></div>
              <span className="returnToLaunchLink"></span>
              </span>
            </Col>
            </Row>
            <Row className="resultsRow">
            <Col>
              <span><Image className="resultsIcon" src={successIcon}/><span className="resultsHeader">
                {deviceReadiness.results.device.success.header}
              <span className="resultsBold">{deviceReadiness.results.device.success.state}</span></span>
              <div className="resultsSubText"></div>
              <span className="returnToLaunchLink"></span>
              </span>
            </Col>
            
            </Row>
            <Row className="resultsRow">
             
                {state.sessionState.selectedAssessmentMode === "online" && 
                <Col>
                  {/* Connection Pending(wait) */}
                  {state.networkReadinessState.executionState.state === "Pending" && 
                  <span className="networkTextContainer"><Image className="resultsIcon over waitingConnectionIcon" src={waitIcon} onClick={onSkipStressTest}/>
                  <Image className="resultsIcon under waitingConnectionIcon" src={waitIconBkgrnd}/>
                  <span className="resultsHeader networkAlignment"> {deviceReadiness.results.stressTest.wait.header}
                  <span className="resultsBold stressTestWaiting">{deviceReadiness.results.stressTest.wait.state}</span></span>
                  <div className="resultsSubText "><Interweave content={deviceReadiness.results.stressTest.wait.message}/>
                  <br/>
                  <span className="returnToLaunchLink"  onClick={onSkipStressTest}>{content.actions.skipStressTest}</span>
                    </div>
                
                  </span>
                  }
                  {/* Connected Successfully */}
                  {state.networkReadinessState.executionState.state === "Completed" && 
                  <span><Image className="resultsIcon" src={successIcon}/>
                  <span className="resultsHeader networkAlignment"> {deviceReadiness.results.stressTest.success.header}
                  <span className="resultsBold">{deviceReadiness.results.stressTest.success.state}</span></span>
                  <div className="resultsSubText"><Interweave content={deviceReadiness.results.stressTest.success.message}/></div>
                  </span>
                  }
                  {/* Connection Skipped */}
                    {state.networkReadinessState.executionState.state === "Skipped" && 
                  <span className="networkTextContainer ">{manualSkip ? <Image className="resultsIcon" src={warning}/>: <Image className="resultsIcon" src={incomplete}/>}
                  <span className="resultsHeader networkAlignment"> {deviceReadiness.results.stressTest.skipped.header}
                  <span className="resultsBold">{deviceReadiness.results.stressTest.skipped.state}</span></span>
                  <div className="resultsSubText skipTextWrap">{manualSkip && <Interweave content={deviceReadiness.results.stressTest.skipped.message}/>}
                  </div>
                  </span>
                } 
                  {/* Stress test Incomplete */}
                  {state.networkReadinessState.executionState.state === "Incomplete" && 
                  <span className="networkTextContainer "><Image className="resultsIcon" src={incomplete}/>
                  <span className="resultsHeader networkAlignment"> {deviceReadiness.results.stressTest.incomplete.header}
                  <span className="resultsBold">{deviceReadiness.results.stressTest.incomplete.state}</span></span>
                  <div className="resultsSubText skipTextWrap"><Interweave content={deviceReadiness.results.stressTest.incomplete.message}/></div>
                  </span>
                  } 
                  {/* Stress test Failed */}
                  {state.networkReadinessState.executionState.state === "Failed" &&
                  <span className="networkTextContainer "><Image className="resultsIcon" src={error}/>
                  <span className="resultsHeader networkAlignment"> {deviceReadiness.results.stressTest.failed.header}
                  <span className="resultsBold">{deviceReadiness.results.stressTest.failed.state}</span></span>
                  <div className="resultsSubText skipTextWrap"><Interweave content={deviceReadiness.results.stressTest.failed.message}/></div>
                  </span>
                  } 
                </Col>
              } 
            </Row>
            </>)}
       {state.deviceState.deviceType === "SBE" ? (
        <Row className="resultsRow launchActionButton">
        <Col>
        <Button className="continue-assessment" onClick={onLaunchAssessment}>{content.actions.continueToAssessment}</Button>
        </Col>
          </Row>
       ) :
       (state.sessionState.selectedAssessmentMode === "ncs" || state.networkReadinessState.executionState.state === "Skipped" || state.networkReadinessState.executionState.state === "Completed" || state.networkReadinessState.executionState.state === "Incomplete") && 
        <Row className="resultsRow launchActionButton">
        <Col>
        <Button className="launch-assessment" onClick={onLaunchAssessment}>{content.actions.launchAssessment}</Button>
        </Col>
          </Row>
        
        }
       {(state.networkReadinessState.executionState.state === "Failed") &&
       <Row className="resultsRow exitAssessmentButton">
       <Col>
       <Button className="exit-assessment" onClick={()=>{window.close()}}>{content.actions.exit}</Button>
       </Col>
         </Row>
          }
      
       </div>
      }
       </Container></>
       
       }
      
       </>}
    
      </FrameBody>
    )
  }

  